/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { FormElement } from "../FormElement";
import { IFormElementConfig } from "../IFormElementConfig";
import { FormModel } from "../FormModel";
import { IFormFieldBaseConfig, FormFieldBase } from "./FormFieldBase";
import { FORM_EL_TYPE } from "../FormElementTypes";

/**
 * Element config
 */
export interface IFormFieldSelectConfig extends IFormFieldBaseConfig<string> {
	options: Array<{
		value: string;
		label: string;
	}>
	align?: "left"|"center"|"right";
}

/**
 * Field Text
 */
export class FormFieldSelect extends FormFieldBase<IFormFieldSelectConfig> {

	/**
	 * Element constructor
	 *
	 * @param model Model instance
	 * @param parent Parent element
	 * @param config Element configuration
	 */
	public constructor(
		protected model: FormModel,
		protected parent: FormElement<any>,
		protected config: IFormFieldSelectConfig
	) {

		super(model, parent, FORM_EL_TYPE.FIELD_SELECT, config, config.options[0] ? config.options[0].value : "");

	}

}

/**
 * Declares selection field
 *
 * @param config Config
 */
export function FieldSelect(
	config: IFormFieldSelectConfig
) {

	return (model, parent) => new FormFieldSelect(model, parent, config);

}
